// extracted by mini-css-extract-plugin
module.exports = {"mainWrapper":"Description_mainWrapper__1wHp8"};